export default {"src":"__ASTRO_ASSET_IMAGE__Blq30rS3__","width":261,"height":207,"format":"png"}